import { render, staticRenderFns } from "./AcessoStats.vue?vue&type=template&id=33b9afe6&"
import script from "./AcessoStats.vue?vue&type=script&lang=js&"
export * from "./AcessoStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports